/* eslint-disable global-require */
/* eslint-disable import/no-unresolved */
const processInclude = require('base/util');
const contactUs = require('./contactUs/contactUs');

$(document).ready(() => {
    processInclude(contactUs);
});
